import Uc from '../../assets/portfolio_img/uc.avif';
import Cvbuilder from '../../assets/portfolio_img/cvbuilder.JPG';
import Olx from '../../assets/portfolio_img/Olx.png';
import Onlineexam from '../../assets/portfolio_img/Onlineexam.png';
import Gps from '../../assets/portfolio_img/Gps.png';
import Netflix from '../../assets/portfolio_img/Netflix.png';


export const projectsData = [
    {
    id: 1,
    image: Uc,
    title: 'AI Driven E-Commerce app',
    category: 'Python-Django',
    description:'Python,Javascript,Django,Open AI,Mysql',
    code: 'https://github.com/Maneshnarayanan/AI-DRIVEN-E-COMMERCE',
    demo: 'https://img.freepik.com/free-vector/construction-landing-page-template_52683-11358.jpg?t=st=1723116522~exp=1723120122~hmac=2cc56f6be742ad33f06ae61f029b7f96bf8b8004b9563eec74ecfeb899fb22be&w=1060'
  },
  {
    id: 2,
    image: Cvbuilder,
    title: 'Online CV Builder',
    category: 'Python-Django',
    description:'Python,Javascript,Django,Bootstrap',
    code: 'https://github.com/Maneshnarayanan/ONLINE-CV-BUILDER',
    demo: 'https://cvbuilder1.pythonanywhere.com'
  },
  {
    id: 3,
    image: Olx,
    title: 'Olx clone',
    category: 'React',
    description:'React,Firebase',
    code: 'https://github.com/Maneshnarayanan/olx-clone-react-app',
    demo: ''
  },
  {
    id: 4,
    image: Onlineexam,
    title: 'Online Examination',
    category: 'Python-Django',
    description:'Python,Django,Bootstrap,Mysql',
    code: 'https://github.com/Maneshnarayanan/ONLINE-EXAMINATION-SYSTEM-PYTHON-DJANGO',
    demo: ''
  },

  {
    id: 5,
    image: Netflix,
    title: 'Netflix Clone',
    category: 'React',
    description:'React,Axios,TMDB API',
    code: 'https://github.com/Maneshnarayanan/Netflix-clone-dynamic',
    demo: ''
  },

  {
    id: 6,
    image: Gps,
    title: 'Official website Launch',
    category: 'Other',
    description:'html,CSS,Javascript',
    code: 'https://www.greenwoodspublicschool.org/',
    demo: 'https://www.greenwoodspublicschool.org/'
  },
    
 

];

export const projectsNav = [
  {
    name: 'all',
  },
  {
    name: 'React',
  },
  {
    name: 'Python-Django',
  },
  {
    name: 'Other',
  },
]
